<template>
	<div class="control">
		<div class="form-group">
			<select :id="'form-' + parent.specification" class="form-control selectpicker" v-on:change="updateFilters" v-model="value">
				<option v-if="parent.placeholder"v-bind:value="''">{{ parent.placeholder }}</option>
				<option v-bind:class="value.customClassName" v-bind:value="value.Value" v-for="value in flattenedControlOptions" v-bind:key="value.Value">{{ value.Name }}</option>
			</select>
		</div>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
		props: ['control', 'parent'],
		data: function () {
			return {
				value: (this.parent.defaultValue !== null && this.parent.defaultValue !== undefined) ? this.parent.defaultValue : this.parent.placeholder,
				startValue: (this.parent.defaultValue !== null && this.parent.defaultValue !== undefined) ? this.parent.defaultValue : this.parent.placeholder,
			}
		},
		computed: {
			...mapState({
				specification: state => state.listing.specification,
			}),

			flattenedControlOptions: function () {
				//let flattenedControlOptions = [];
				const arrayLike = document.querySelectorAll('.dropdown.bootstrap-select .dropdown-menu li a');
				let flattenedControlOptions = Array.from(arrayLike);
				this.control.forEach(element => {
					element.customClassName = "parent";
					flattenedControlOptions.push(element);
					if (element.Options) { 
						element.customClassName = "parent has-child";
						element.Options.forEach(child => {
							child.customClassName = "child";
							flattenedControlOptions.push(child);
						});
					}
				});
				return flattenedControlOptions;
			},
		},
		mounted: function () {
			let initialData = this.$store.state.listing.specification[this.parent.specification];
			if (initialData != null && initialData !== '') {
				this.value = initialData;
			}
			// clear current input on reset
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/resetSpecification') {
					this.value = this.startValue;

					setTimeout(() => {
						$('.selectpicker').selectpicker('refresh');
					}, 500);
				}
			});
		},
		methods: {
			...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
			updateFilters() {
				// if hitting api on each checkmark change
				this.updateSpecification({ key: this.parent.specification, value: this.value });
			},
		}
	}
</script>